import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-ktostamm-kunde-subnummer-template',
  imports: [],
  templateUrl: './ktostamm-kunde-subnummer.template.html',
  styleUrls: ['./ktostamm-kunde-subnummer.template.css'],
})
export class KtostammKundeSubnummerTemplate implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
